export const ONLINE = '#76B62A'
export const BUSY = '#DC4614'
export const BERIGHTBACK = '#FFDF00'
export const OFFLINE = '#BEBEBE'

export const RELIABLE = '#006446'
export const WITHRESERVATIONS = '#FFDF00'
export const UNRELIABLE = '#DC4614'
export const NONE = ''
